import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { withTolgee } from '@tolgee/i18next';
import { tolgee } from './tolgee';

const isProduction = process.env.NODE_ENV === 'production';

withTolgee(i18n, tolgee)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: !isProduction,
    lng: 'es-MX',
    fallbackLng: {
      'es': ['es-MX'],
      'default': ['es-MX']
    },
    supportedLngs: ['es-MX', 'en', 'es'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    // ⚡ MANDATO PLURAL:
    // El namespace 'translations' es el único y por defecto
    ns: ['translations'],
    defaultNS: 'translations',
  });

export default i18n;
